<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">
  {{alert.message}}
</re-alert>
<h1  >Parameters</h1>

<div class="table-responsive afterHeader">
  <table class="table table-striped table-bordered user-list">
    <thead class="thead">
      <tr>
        <th>ID</th>
        <th>Key</th>
        <th>Value</th>
        <th>Configuration ID</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let parameter of parameters">
        <td>
          {{parameter.id}}
        </td>
        <td class="parameter-list-keyvalue" *ngIf="!isReadOnlyUser">
          <a [routerLink]="['/ect/parameters/detail/', parameter.id ]">{{ parameter.key }}</a>
        </td>
        <td class="parameter-list-keyvalue" *ngIf="isReadOnlyUser">
          {{ parameter.key }}
        </td>
        <td class="parameter-list-keyvalue">
          {{ parameter.value }}
        </td>
        <td>
          <a [routerLink]="['/ect/configurations/detail/', parameter.configurationId ]">{{ parameter.configurationId }}</a>
        </td>
      </tr>
      <tr *ngIf="!loading && (!parameters || parameters.length === 0)">
        <td class="text-center h6" colspan="6">No Matching Records Found.</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="spinner spinner-sm" *ngIf="loading">
  <div class="lspinner"></div>
</div>
